import { getBackendStorage } from '@core/core/modules'
import { AppRoutes } from '@core/core/routes'
import { useAppDispatch, userLogout } from '@core/core/store'
import { useMetaChange } from '@library/hooks'
import { PersistenceContextProvider } from '@library/model'
import messenger from 'common/messenger'
import type { FC } from 'react'
import { lazy } from 'react'

import { AppContext } from './AppContext'
import { ModalContainer } from './components'

const AuthFrontend = lazy(() => import('@utils/AuthOuterAppWrapper'))

const App: FC = () => {
  const dispatch = useAppDispatch()
  useMetaChange('Геомейт')

  return (
    <AppContext>
      <AuthFrontend coreMessenger={messenger}>
        {(getToken, logout) => (
          <PersistenceContextProvider storage={getBackendStorage()}>
            <AppRoutes
              getToken={getToken}
              logout={() => {
                dispatch(userLogout())
                logout()
              }}
            />
          </PersistenceContextProvider>
        )}
      </AuthFrontend>
      <ModalContainer />
    </AppContext>
  )
}

export default App
